// Coming Soon destination records.
import { ASSETS } from "./assets";

export const DESTINATIONS = {
  india: [
    {
      id: "pondicherry",
      name: "Pondicherry",
      teaser: "Coastal ecology, French-Tamil heritage, community life and the art of slow observation.",
      themes: ["Ecology & Biodiversity", "Heritage & Culture", "Community & Connection"],
      image: ASSETS.pondicherry,
    },
    {
      id: "jaipur",
      name: "Jaipur",
      teaser: "Living heritage, craft, architecture and the stories held within a historic city.",
      themes: ["Heritage & Culture", "Creativity & Expression", "Observation & Inquiry"],
      image: ASSETS.jaipur,
    },
    {
      id: "hampi",
      name: "Hampi",
      teaser: "A landscape of stone and water, where archaeology and living heritage meet.",
      themes: ["Heritage & Culture", "Observation & Inquiry", "Systems Thinking"],
      image: ASSETS.hampi,
    },
    {
      id: "ladakh",
      name: "Ladakh",
      teaser: "High-altitude landscapes, adaptation, ecology and life in a mountain environment.",
      themes: ["Ecology & Biodiversity", "Systems Thinking", "Community & Connection"],
      image: ASSETS.ladakh,
    },
  ],
  international: [
    {
      id: "japan",
      name: "Japan",
      teaser: "Living traditions, technology, food and the relationship between old and new.",
      themes: ["Heritage & Culture", "Systems Thinking", "Creativity & Expression"],
      image: ASSETS.japan,
    },
    {
      id: "south-korea",
      name: "South Korea",
      teaser: "Urban culture, history, food, landscapes and contemporary life.",
      themes: ["Heritage & Culture", "Observation & Inquiry", "Community & Connection"],
      image: ASSETS.southKorea,
    },
    {
      id: "indonesia",
      name: "Indonesia",
      teaser: "Island ecosystems, biodiversity and the relationship between people and place.",
      themes: ["Ecology & Biodiversity", "Community & Connection", "Sustainability & Stewardship"],
      image: ASSETS.indonesia,
    },
  ],
};
